webpackJsonp([165194195783766],{

/***/ 1825:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/paris-motor-show-2018-week-1-round-up/"},"frontmatter":{"title":"Paris Motor show 2018 Week 1 Round up","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450-paris-ms-article-header-image-v1-93ad4148d48784a50cdc4441add25d86.jpg"}}},"original":"/img/1160x450-paris-ms-article-header-image-v1.jpg"},"category":"News"}}}]}},"pathContext":{"tag":"News"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-news-3f6e24f267fb6ace3756.js